import React, { useState } from "react";
import { ToolbarThinWrapper } from "components/Toolbar/ToolbarThinWrapper";
import { useTaskDashboardContext } from "../context";
import { taskListColumns } from "../gridColDefinition";
import { DataGridDashboardWrapper } from "components/Wrappers/DataGrid/DataGridDashboardWrapper";

export const TaskListForDashboard = ({ pageName, type }) => {
  const { acceptedRecords, pendingRecord } =
    useTaskDashboardContext();
  const [openLogModal, setOpenLogModal] = useState(false);
  const [logList, setLogList] = useState([]);
  const records = type === "pending" ? pendingRecord : acceptedRecords;
  const [sortedRecords, setSortedRecords] = useState(records);

  return (
    <>
      <ToolbarThinWrapper />
      <div style={{ width: "100%" }}>
        <DataGridDashboardWrapper
          rows={sortedRecords}
          getRowHeight={() => "auto"}
          disableRowSelectionOnClick
          disableColumnMenu={true}
          columns={taskListColumns({
            records,
            setOutputRecords: setSortedRecords,
            openLogModal,
            setOpenLogModal,
            logList,
            setLogList,
            pageName,
          })}
          columnVisibilityModel={{
            id: false,
          }}
        />
      </div>
    </>
  );
};
